<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label>Transportadora</label>
      <multiselect
        v-model="transportadoraSelected"
        :options-limit="300"
        :limit="2"
        :limit-text="limitText"
        :options="optionsTransportadora"
        track-by="value"
        label="label"
        id="transportadora"
        :hide-selected="true"
        placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
        :searchable="true"
        :internal-search="false"
        :loading="isLoadingTransportadora"
        @search-change="listaTransportadora"
      ></multiselect>
      <b-form-feedback
        class="text-danger"
        v-text="form.errors.get('pessoa_id')"
        v-if="form.errors.has('pessoa_id')"
      ></b-form-feedback>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      transportadora: [],
      optionsTransportadora: [],
      transportadoraSelected: [],
      isLoadingTransportadora: false,
      errors_array: [],
      form: new Form({ docfis: [], pessoa_id: "" }),
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    transportadoraSelected(obj) {
      this.form.pessoa_id = obj.value;
    },
    categoriaSelected(obj) {
      this.form.categoria = obj.value;
    }
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.pesmot_id);
      }
    },
    onCreate(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.form.reset();
      this.form.docfis = [];
      this.form.docfis = data;
      this.transportadoraSelected = [];
      this.form.docfis = data;
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.form.docfis = [];
      this.transportadoraSelected = [];
      this.errors_array = "";
      this.errors_array = [];
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.dt_vencimento_cnh = this.formatDateSubmit(
        this.form.dt_vencimento_cnh
      );
      this.form
        .post("/api/docfiscal/redespacho/store")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
      console.log(this.form);
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.dt_vencimento_cnh = this.formatDateSubmit(
        this.form.dt_vencimento_cnh
      );
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then(response => {
          new ReturnApi(response, this);

          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then(response => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            const items = response.items || [];
            const itemsF = response.itemsF || [];
            const itemsE = response.itemsE || [];

            if (items.length > 0) {
              items.forEach(obj => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    )+
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            if (itemsF.length > 0) {
              itemsF.forEach(obj => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            if (itemsE.length > 0) {
              itemsE.forEach(obj => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch(errors => {
            new ReturnApi(errors, this);
          });
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>